angular.module('graph').controller('ph-document', [
    '$scope', 'ph-core', 'ph-paging', 'ph-touch-service', '$rootScope', '$timeout',
    function ($scope, $core, $paging, $phtouch, $root, $timeout) {

        $scope.documents = [];

        $scope.$page    = 0;

        $scope.$let     = 0;

        $scope.$paging  = $paging.new();

        $scope.loader   = 1;

        $scope.entry_id = 0;

        $scope.entry    = null;

        $scope.query    = $core.$uri.$query.new({
            page    : 0,
            let     : 0
        });

        $scope.$on('ph-root-document-update', function($e, $query) {
            $scope.$paging  = $paging.new();

            $scope.$page = 0;

            $query.set('page', 0).set('let', 0);

            $scope.query = $query;

            $scope.documents = [];

            $scope.find();
        });

        $scope.$entry = function (name, id) {
            if (name) $scope.entry = name;
            if (id)   $scope.entry_id = id;
        };

        function make(state)
        {
            if (state === 'entry') {
                var $entry = $scope.entry !== null ? $scope.entry + '/' : '';
                $entry += $scope.entry_id !== 0 ? $scope.entry_id + '/' : '';

                return $entry;
            }

        }

        $scope.filtrate = function (value) {
            return (value && value.length > 0 && value.length <= 255);
        };

        $scope.init  = function(name, id) {
            if (name) $scope.entry = name;
            if (id)   $scope.entry_id = id;

            $scope.find();

        };

        $scope.filter = function() {
            $scope.documents     = [];

            $scope.$page    = 0;

            $scope.$let     = 0;

            $scope.loader   = 1;

            $scope.find();
        };

        $scope.find = function (next) {
            //if ($scope.$paging.pages > -1 && $scope.$paging.pages === $scope.$paging.page)
            //    return;

            var $query = $scope.query.set(
                'page', +(++$scope.$page)
            ).str();

            $core.get('/xhr/' + make('entry') + 'documents?' + $query)
                .then(function($response) {
                    if ($response.data.state === 0 && $response.data.data.length > 0) {
                        $scope.$paging.pages = $response.data.pages;
                        $scope.$paging.page = $response.data.page;

                        /**
                         *
                         */
                        $scope.documents = $scope.documents.concat(
                            $response.data.data
                        );

                        if (next) next();
                    }

                    $scope.loader = 0;
                });
        };

        $scope.update = function ($document) {
            $timeout(function () {
                $core.post('/xhr/' + make('entry') + 'document/' + $document.id, {name: $document.name})
                    .then(function ($response) {
                        if ($response.data.state === 0) {
                            //
                        }
                    });
            }, 10);
        };

        $scope.delete = function ($document) {
            $core.delete('/xhr/' + make('entry') + 'document/' + $document.id)
                .then(function ($response) {
                    if ($response.data.state === 0) {
                        $scope.documents.splice(
                            $scope.documents.indexOf($document),
                            1
                        )
                    }
                });
        };

        $scope.upload = function () {
            if ($scope.form.upload.document.$valid === true) {
                $root.screen_lock = 1;

                $timeout(function () {
                    $core.post('/xhr/' + make('entry') + 'documents/', {
                        name: $scope.document.name,
                        document: $scope.document.base
                    }).then(function ($response) {
                        $scope.error = {};

                        $root.screen_lock = 0;

                        if ($response.data.state === 0) {
                            $scope.documents.unshift(
                                $response.data.data
                            );
                        } else {
                            $scope.error = $response.data.data;

                            $root.$broadcast('ph-modal-show', $response.data.data.document);
                        }
                    }, function () {
                        form.upload.document.$error.load = 1;

                        $root.screen_lock = 0;
                    });
                });
            }
        };
    }
]);

angular.module('graph').controller('ph-document-filter-ctrl', [
    '$scope', '$rootScope', 'ph-core',
    function ($scope, $root, $core) {

        $scope.ui = {
            mode: 'man'
        };

        $scope.attachment = {
            'document'          : 'Document',
            'spreadsheet'       : 'Spreadsheet',
            'presentation'      : 'Presentation',
            'archive'           : 'Archive',
            'agenatrader'       : 'Agenatrader'
        };

        $scope.filter = {
            attachment: {
                'document'         : true,
                'spreadsheet'      : true,
                'presentation'     : true,
                'archive'          : true,
                'agenatrader'      : true
            },
            select: {
                attach: {
                    all: true
                }
            }
        };

        $scope.query = {
            attach: new Array,
            compile: function () {
                $scope.query.attach = new Array;

                for (var type in $scope.filter.attachment) {
                    if ($scope.filter.attachment[type] === true)
                        $scope.query.attach.push(type)
                }
            }
        };

        $scope.filtrate = function () {
            var $query = $core.$uri.$query.new({
                type: encodeURIComponent($scope.query.attach.join(','))
            });

            $root.$broadcast('ph-root-document-update', $query);
        };

        $scope.fn = {
            'attach' : {
                'all': function () {
                    if ($scope.filter.select.attach.all === true) {
                        for (var type in $scope.filter.attachment)
                            $scope.filter.attachment[type] = true;
                    } else {
                        for (type in $scope.filter.attachment)
                            $scope.filter.attachment[type] = false;
                    }

                    $scope.query.compile();
                },
                'change': function () {
                    $scope.filter.select.attach.all = false;

                    for (var type in $scope.filter.attachment) {

                        if ($scope.filter.attachment[type] === true) {
                            $scope.filter.select.attach.all = true;
                            break;
                        }
                    }

                    $scope.query.compile();
                }
            },
            'filter' : {
                all: function () {
                    $scope.ui.mode = 'all';

                    var $q = $core.$uri.$query.new();

                    $scope.fn.filter.cast($q);
                },
                man: function () {
                    $scope.ui.mode = 'man';
                    var $q = $core.$uri.$query.new({
                        type: encodeURIComponent($scope.query.attach.join(','))
                    });

                    $scope.fn.filter.cast($q);
                },
                cast: function ($query) {
                    $root.$broadcast('ph-root-document-update', $query);
                }
            }
        };

        $scope.fn.attach.all();
    }
]);

angular.module('graph').controller('ph-read-documents-tab', [
    '$scope', '$controller', '$rootScope', 'ph-touch-service', 'ph-broadcast',
    function ($scope, $controller, $root, $phtouch, $broadcast) {
        angular.extend(this, $controller('ph-document', {$scope: $scope}));

        var $module     = 'ph-read-documents-tab';

        $phtouch.$watch($scope, $module, function() {
            $phtouch.$touch($module, function() {
                $scope.init();
            });
        });
    }
]);